import React from 'react';
import {
  Row, Col, Card, CardBody,
  CardHeader,
} from 'reactstrap';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';

function BCFails(props) {
  const { t } = props;
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{t('BC create fails')}</CardHeader>
              <CardBody>
                <Can i="see" this="bc">
                  <BaseGrid
                    url={url.GET_BIGCOMMERCE_FAILS}
                    hasSearch
                    config={{
                      columns: {
                        id: { label: props.t('ID'), sort: true },
                        listing_id: {
                          label: props.t('Listing ID'),
                          sort: true,
                          link: {
                            to: '/listing/%listing_id%',
                          },
                        },
                        sku: {
                          label: 'Sku',
                          format: (f, x) => x.listing.sku,
                        },
                        title: {
                          label: props.t('Title'),
                          format: (f, x) => x.listing.title,
                        },
                        attempted_at: {
                          label: props.t('Attempted At'),
                          sort: true,
                          format: (date) => (new Date(date).toLocaleString()),
                        },
                        message: { label: props.t('Message'), sort: false },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 100,
                      },
                    }}
                  />
                </Can>

                <Can not i="see" this="bc"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

BCFails.defaultProps = {
  t: (x) => (x),
};

BCFails.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(BCFails));
